export const uiObject = `query uiObject($id: ID! = 1) {
    uiObject(id: $id) {
      id
    	title
    	subtitle
    	desc	
      logo{
        url
      }
      videoUrl
      banenrImage{
        url
      }
      BannerColor
      url
      isOpen
      bannerLabels{
        id
        title
        image{
          url
        }
        about
      }
      UiModuleA{
        id
        title
        about
        image{
          url
        }
      }
      UiModuleB{
				id
        title
        desc
        titleAndUrlImage{
          id
          title
          bgImg{
            url
          }
          subTitle
          url
          file{
            url
          }
        }
      }	
      classLists{
        id
        title
        subTitle
        desc
      }
    	SkillModules{
        id
        title
        url
        image{
          url
        }
        ttitleAndDesc{
          id
          title
          desc
        }
      }
    	ui_teachers{
        id
        name
        quarters
        details
        realName
        headerImage{
          url
        }
      }
  	}
}`